<template>
  <div class="compare-main pcproducts">
    <el-backtop target=".compare-main"></el-backtop>
<!--    <div class="vivideot" v-if="vitohomevid">-->
<!--      <div class="vividecont">-->
<!--        <video :src="vivideotcon" autoplay="autoplay" controls></video>-->
<!--        <div class="el-icon-circle-close" @click="viclosevideo"></div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="pchome-headerss">
      <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
    </div>

    <div class="videohea" :class="producthea_nav?'producthea_nav':''">
      <div class="videohea-left">
        {{vidcenter}}
      </div>
      <div class="videohea-right">
        <div class="videohea-righttitle">
          <!-- <div class="producthearight-item" @click="videoclinav(0)" :class="videotopnavind==0?'viotopna':''"> -->
<!--          <div class="producthearight-item" @click="videoclinav(0)" :style="videotopnavind==0?'color:'+nav_color : ''">-->
<!--            {{videonavall}}-->
<!--          </div>-->
          <!-- <div class="producthearight-item" v-for="(item,index) in videoclassallss" :class="videotopnavind==item.id?'viotopna':''" :key="index" @click="videoclinav(item.id)"> -->
          <div class="producthearight-item" v-for="(item,index) in category.options" :style="videotopnavind==item.id?'color:'+nav_color : ''" :key="index" @click="videoclinav(item.id)" v-if="item.en_name">
            {{item.en_name}}
          </div>
        </div>
        <div class="videohea-righticon" @click="videodwon">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />
        </div>
      </div>
    </div>
    <div style="padding:10px 0;opacity:0" v-if="producthea_nav">
      <div class="videohea-left">
        {{vidcenter}}
      </div>
    </div>
    <div class="linesd"></div>

    <pc-compare-table
        ref="compareTableRef"
        :column="attrOptions"
        :list="compareProductList"
        @removeCompareProduct="removeCompareProduct"
        @addCompareProduct="addCompareProduct"
        :productDic="productDic"
    ></pc-compare-table>

    <footers ref=is_change></footers>
  </div>
</template>

<script>
import headers from "@/common/header.vue";
import footers from "@/common/footers.vue";
import pcCompareTable from "@/components/compare/pc-table"
import {session} from "../../storage/storage";
export default {
  name: 'pccompare',
  components: {
    footers,
    headers,
    pcCompareTable
  },
  data() {
    return {
      vidcenter:'Specifications & Configuration Comparison',
      videonavall:'全部',
      videoclassallss:'',
      producthea_nav:false,
      videotopnavind:0,
      nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
      videonavnums:5,
      lang: session.get('lang'),
      compareProductList: [],
      attrOptions: [
        {
          value: -2,
          label: 'Prodcut Model'
        },
        {
          value: -1,
          label: 'Category'
        },
      ],
      productDic: [],
      selectedProductId: '',
      cateAll: [],
      cateOption: [],
      category: {
        limit: 8,
        all: [],
        options: [],
        is_all: false
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      icons:{
        close: process.env.VUE_APP_BASE_URL + '/assets/img/close.png',
        empty: process.env.VUE_APP_BASE_URL + '/assets/img/x.png',
        confirm: process.env.VUE_APP_BASE_URL + '/assets/img/g.png'
      },
    }
  },
  async created() {
    this.videoclassall()
    // this.videoclasslist()
    this.heshow=true
  },
  watch:{
    '$route': 'getParams'
  },
  mounted() {

    document.addEventListener('scroll',this.handleScroll,false)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('scroll', this.handleScroll,false)
    })
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      console.log('手机手机21321321')

      this.$router.push({path:'/ph/compare',query:{e:this.$route.query.e}})
    }

    sessionStorage.setItem('page',JSON.stringify({name:'pc/compare',data:false}))

  },
  methods: {
    removeCompareProduct(index){
      this.compareProductList.splice(index, 1)
      this.handleCompareData()
    },
    async addCompareProduct(id){
      let res = await this.$api.get_compare_product({id})
      this.compareProductList.push({
        ...res.data,
      })
      this.handleCompareData()

    },
    resetAttrOptions(){
      this.attrOptions = [
        {
          value: -2,
          label: 'Prodcut Model',
          is_center: 1
        },
        {
          value: -1,
          label: 'Category',
          is_center: 0
        },
      ]
    },
    handleCompareData(){
      this.resetAttrOptions()
      this.compareProductList.forEach((item) => {
        if (!item.parameter) return;
        // const p = item.parameter.filter((parameter) => {
        //   if(parameter.value != ''){
        //     return parameter
        //   }
        //   if(parameter.is_check == 1){
        //     parameter.value = parameter.is_check
        //     return parameter
        //   }
        //   return false
        // })
        // item.parameter = p
        item.parameter.forEach((parameter) => {
          if(parameter.attr){
            const exists = this.attrOptions.some(attr => attr.value === parameter.attr.id);
            if (!exists) {
              this.attrOptions.push({
                value: parameter.attr.id,
                label: parameter.attr.name,
                is_center: parameter.attr.is_center,
                sort: parameter.attr.sort
              });
            }
          }
        });
      });
      this.attrOptions.sort((a, b) => a.sort - b.sort);

      this.compareProductList.forEach((item) => {
        if (!item.parameter) item.parameter = [];
        const toAdd = [];
        this.attrOptions.forEach(attr => {
          if (attr.value === -1 || attr.value === -2) return;
          const hasAttr = item.parameter.some(p => p.attr && p.attr.id === attr.value);
          if (!hasAttr) {
            toAdd.push({
              attr: {
                id: attr.value,
                name: attr.label
              },
              value: '',
              is_check: 0,
              is_center: 0,
              attr_id: attr.value
            });
          }
        });
        item.parameter.push(...toAdd);
      });
    },
    async changeProduct(){
      await this.addCompareProduct(this.selectedProductId)
    },
    videoclinav(id){
      this.videotopnavind=id
      this.classidd=id
      this.$refs.compareTableRef.clearSelectedProductId()
      this.compareProductList = []
      this.resetAttrOptions()

      // this.videoclasslist()
      this.getProductDic()

    },
    videodwon(){
      this.category.is_all = this.category.is_all ? false : true
      if(this.category.is_all){
        this.category.options = this.category.all
      }else {
        this.category.options = this.category.all.slice(0, this.category.limit)
      }
      // if(this.videonavnums==5){
      //   this.videonavnums=50
      //   this.videoclassall()
      // }else{
      //   this.videonavnums=5
      //   this.videoclassall()
      // }
    },
    getProductDic(){
      this.$api.get_product_dic({
        lang:'en',
        compare_category_id:this.videotopnavind,
        is_compare: 1,
      }).then((res) => {
        this.productDic = res.data
      });
    },
    videoclassall(){
      let data={
        // lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
        lang: 'en',
        channel_id: 1,
      }
      this.$api.get_compare_category().then((res) => {
        this.category.all = res.data
        this.category.options = this.category.all.slice(0, this.category.limit)
        this.videoclassallss=res.data
        if(!this.videotopnavind){
          this.videoclinav(this.category.all[0].id)
        }
      });
    },
    ChangeEmit(){ //子组件传递
      //主动调用子组件
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
      this.getParams()
      this.videoclassall()
      // this.videoclasslist()
      this.pageParam() //页面静态参数
    },
    getParams () {
      this.id = this.$route.query.e
      // this.$refs.is_change.scrollIntoView('vidscas'+this.$route.query.e)
    },
    pageParam(){},
    handleScroll () {
      let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if(scrollTop>head_height){
        // if(scrollTop>this.scroll_height){
        this.producthea_nav = true
        // }else{
        // 	this.producthea_nav = false
        // }
        this.scroll_height = scrollTop
      }else{
        this.producthea_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop,'pcelites')
    },
  }
}
</script>

<style scoped>

body{
  margin: 0;
  padding: 0;
  background: #fff;
}
.pcproducts{
  //width: 100%;
  //height: 100%;
  position: relative;
  background: #fff;
}
.pchome-headerss{
  width: 100%;
  position: relative;
  background-size: 100% 100%;
  padding-top:119px;
  box-sizing: border-box;
}


.videohea{
  width: 1400px;
  /* height: 80px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 260px;
}
.videohea-left{
  font-size: 28px;
  color: #5d5f5f;
}
.videohea-right{
  display: flex;


}
.videohea-righttitle{
  max-width: 680px;
  display: flex;
  font-size: 16px;
  flex-wrap: wrap;
  color: #5d5f5f;
}
.producthearight-item{
  margin-bottom: 10px;
  cursor: pointer;
  margin-left: 24px;
}
.producthearight-item:first-child{
  //margin-left: 0px;
  margin-left: 24px;
}
.videohea-righticon{
  width: 20px;
  height: 20px;
  margin-left: 9px;
  display: flex;
  align-items: center;
}
.videohea-righticon img{
  width: 100%;
  height: 100%;
}
.linesd{
  height: 1px;
  background: #EAEAEA;
}

.nav-left{
  width: 100px;
  height: 50px;
}
.nav-left img{
  width: 100%;
  height: 100%;
}
/* .nav-center-item:hover{
  border-bottom: 2px solid #E31E24;
} */

.nav-center-item:first-child{
  margin-left: 0;
}
.nav-right{
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-left: 180px;
}
.nav-right .search{
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.nav-right .search img{
  width: 100%;
  height: 100%;
}
.nav-right .homename{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}
.nav-right .homename img{
  width: 16px;
  height: 16px;
  margin-left: 4px;
}
.nav-right .language{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-right .language img{
  width: 16px;
  height: 16px;
  margin-left: 6px;
}
.producthea_nav{
  top: 0;
  position: fixed;
  z-index: 9;
  background-color: #fff;
  background: rgba(255,255,255,.72);
  backdrop-filter: saturate(180%) blur(20px);
}

.compare-container {
  display: flex;
  font-size: 20px;
  margin-left: 277px;
  margin-top: 26px;
  margin-bottom: 65px;
}





</style>

